import React, { ReactNode } from 'react';

import { StreetBeatChatProvider as SDKProvider, ThreadsProvider } from '@dev-streetbeat/chat';

import { useChatConfig } from 'shared/hooks/useChatConfig';


interface StreetBeatChatProviderProps {
    children: ReactNode;
}

export const StreetBeatChatProvider: React.FC<StreetBeatChatProviderProps> = ({
    children,
}) => {
    const { chatConfig, loading, error } = useChatConfig();

    if (error) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-red-500">
                    <p>Chat initialization failed: {error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-gray-500">
                    Loading user information...
                </div>
            </div>
        );
    }

    return (
        <SDKProvider config={chatConfig}>
            <ThreadsProvider config={chatConfig}>
                {children}
            </ThreadsProvider>
        </SDKProvider>
    );
};
